import ApiService from './ApiService'

export const RequestService = {

  baseURL: process.env.VUE_APP_VIRTUAL_WAITING_ROOM_URL,

  accept (resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/requests/${resource}/accept`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  end(resource, profile) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/requests/${resource}/end?profile=${profile}`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },


  cancel (resource, data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/requests/${resource}/cancel`, data)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  unratedRequests() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/v1/requests/unrated`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  rateRequest(resource, data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/requests/${resource}/rate`, data)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })

  },

  updatePriority (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/requests/${resource}/priority`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  updateDuration (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/requests/${resource}/duration`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  requeue(resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/requests/${resource}/requeue`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  }


}

export const BreaksService = {
  baseURL: process.env.VUE_APP_VIRTUAL_WAITING_ROOM_URL,

  start() {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v1/breaks/new`)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  stop(resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/breaks/end/${resource}`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const StatisticsService = {
  getDispenserStatistics (serviceUrl, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/v1/statistics/dispensers`, params)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  getAudiologistStatistics (serviceUrl, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/v1/statistics/audiologists`, params)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }
}
